import { Alert, Group, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Button } from 'src/design-system/Button';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { useRegenerateMeetingNote } from 'src/meetings/hooks/useRegenerateMeetingNote';
import type { CalendarEvent } from 'src/meetings/models';

type Props = {
  event: CalendarEvent;
};

export function MeetingNoteOutOfDateBanner({ event }: Props) {
  const { flagEnabledAttendeeChangesRefreshOutputs } = useFlags();
  const { meetingNote, canRegenerate, regenerate, isRegenerating } =
    useRegenerateMeetingNote(event);

  if (!flagEnabledAttendeeChangesRefreshOutputs || !meetingNote?.isOutOfDate || !canRegenerate) {
    return null;
  }

  return (
    <Alert variant="light" color="yellow" icon={<IconAlertTriangle size={18} />} mb="md">
      <Group justify="space-between" wrap="nowrap" gap="md">
        <Text size="sm">
          The attendees have changed since this meeting note was generated, so it may name the wrong
          people.
        </Text>
        <Button variant="secondary" size="sm" onClick={regenerate} loading={isRegenerating}>
          Regenerate meeting note
        </Button>
      </Group>
    </Alert>
  );
}
